import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStaff, deleteStaff } from "../../features/staff/staffSlice";
import { fetchAreasStaff } from "../../features/areas/areasSlice";
import Forms from "./Forms";
import Content from "./Content";
import { CustomContainer } from "../Tools";

const Staff = () => {
    const { status} = useSelector(state => state.staff);
    const dispatch = useDispatch();
    useEffect(() => {
        if(status === 'idle'){
            dispatch(fetchAreasStaff());
            dispatch(fetchStaff())
        }
    }, [dispatch, status])
    const title = 'Personal Administrativo';
    return(
        <CustomContainer
            content={<Content />}
            forms={<Forms />}
            fnConfirm={deleteStaff}
            title={title}
        />
    )
}

export default Staff;